import { Fragment, useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import CollapsedSettings from './CollapsedSettings';
import ExpandedSettings from './ExpandedSettings';

import { When } from 'react-if';

const TsSettings = ({ children, onClearDefaultSettings }) => {
  const [areSettingsOpen, setAreSettingsOpen] = useState(false),
        openSettings = useCallback(() => setAreSettingsOpen(true), []),
        closeSettings = useCallback(() => setAreSettingsOpen(false), [])

  return (
    <Fragment>
      <CollapsedSettings openSettings={openSettings}/>
      <When condition={areSettingsOpen}>
        {() => (
          <ExpandedSettings 
              children={children}
              closeSettings={closeSettings}
              onClearDefaultSettings={onClearDefaultSettings}
          />
        )}
      </When>
    </Fragment>
  )
}

TsSettings.propTypes = {
  children: PropTypes.any.isRequired,
  onClearDefaultSettings: PropTypes.func.isRequired,
}

export default TsSettings;